module.exports = __webpack_public_path__ + "static/media/75.8d3b475c.jpg";